/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import initialState from 'software_products/redux/initialState';
import { findVariantByOptionValues } from 'software_products/redux/utils';
import { doAddToCart } from 'shared/thunks';

const softwareProductsService = createSlice({
  name: 'softwareProductsService',
  initialState,
  reducers: {
    selectOption(state, action) {
      state.selectedOptionIndex = action.payload;
      const selectedVariant = findVariantByOptionValues(state);

      if (selectedVariant) {
        state.selectedVariant = selectedVariant;
      }
    },
    changeNumberOfUsers(state, action) {
      state.numberOfUsers = action.payload;
      const selectedVariant = findVariantByOptionValues(state);

      if (selectedVariant) {
        state.selectedVariant = selectedVariant;
      }
    },
    changeLicenseSpan(state, action) {
      state.licenseSpan = action.payload;
      const selectedVariant = findVariantByOptionValues(state);

      if (selectedVariant) {
        state.selectedVariant = selectedVariant;
        state.persistedLicenseSpan = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(doAddToCart.pending, (state) => {
      state.isAddingToCart = true;
    });
    builder.addCase(doAddToCart.fulfilled, (state) => {
      state.isAddingToCart = false;
    });
    builder.addCase(doAddToCart.rejected, (state) => {
      state.isAddingToCart = false;
    });
  },
});

export const {
  selectOption,
  changeNumberOfUsers,
  changeLicenseSpan,
} = softwareProductsService.actions;

export default softwareProductsService.reducer;
